// extracted by mini-css-extract-plugin
module.exports = {"logoSlider":"__logoSlider__j_bYc","marquee":"__marquee__rc_kc","gradientAtMargin":"__gradientAtMargin__meIuP","gradientColorAtDark":"__gradientColorAtDark__OBsOs"};